import React, {Component} from 'react'
import ReactDOM from 'react-dom'

import styles from './Producer.module.scss'

class Producer extends Component {
    scrollToAbout = () => {
        window.scroll({'behavior': 'smooth', 'top': -800});
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        return (
            <>
                <div className={`${styles.producer} ${styles.desktop} ${this.getLanguageClass()}`}>
                    <div className={styles.page}>
                        <div className={styles.page_title}>{this.props.about.producerName}</div>
                        <div className={styles.page_subtitle}>{this.props.about.producerPageName}</div>
                    </div>
                    <div className={styles.content}>
                        <div className={styles.content_overlay}></div>
                        <div className={styles.content_logo}></div>
                        <div className={styles.content_description} dangerouslySetInnerHTML={{__html: this.props.about.producerDescription}}>
                            {/*<div className="justify">*/}
                            {/*    畢業於國立台灣藝術大學廣電系，國立台灣藝術大學電影所肄業。於 2005 年進入影像製作業界，從廣告製作開始，多年來從MV、短片、電視電影，乃至劇情長片，累積了全面、大量且紮實的影像製作經驗，並有著對於創作方向的敏銳度與視角，以及從影像美學的創作思維出發、高度的規劃與執行能力。與台灣新生代導演合作密切。2015年創立邊境映像藝文有限公司後，開始從事電影開發領域的工作。陸續與導演合作參與劇本開發、編撰，也自己嘗試編劇創作等不同面向的發展。並漸漸將工作核心焦點，放在影片製作專案開發、資金募集、國際市場操作等面向。*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
                <div className={`${styles.producer} ${styles.mobile} ${this.getLanguageClass()}`}>
                    <div className={styles.content}>
                        <div className={styles.page}>
                            <div className={styles.page_subtitle}>{this.props.about.producerPageName}</div>
                            <div className={styles.page_title}>{this.props.about.producerName}</div>
                        </div>
                        <div className={styles.content_logo}></div>
                        <div className={styles.content_description} dangerouslySetInnerHTML={{__html: this.props.about.producerDescription}}>
                            {/*<div className="justify">*/}
                            {/*    畢業於國立台灣藝術大學廣電系，國立台灣藝術大學電影所肄業。於 2005 年進入影像製作業界，從廣告製作開始，多年來從MV、短片、電視電影，乃至劇情長片，累積了全面、大量且紮實的影像製作經驗，並有著對於創作方向的敏銳度與視角，以及從影像美學的創作思維出發、高度的規劃與執行能力。與台灣新生代導演合作密切。2015年創立邊境映像藝文有限公司後，開始從事電影開發領域的工作。陸續與導演合作參與劇本開發、編撰，也自己嘗試編劇創作等不同面向的發展。並漸漸將工作核心焦點，放在影片製作專案開發、資金募集、國際市場操作等面向。*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </>
        );
    }

};

export default Producer;
